var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitterLogo = function SvgTwitterLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#twitter-logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 1.705a7.674 7.674 0 0 1-2.121.554A3.564 3.564 0 0 0 17.503.312a7.623 7.623 0 0 1-2.345.854 3.776 3.776 0 0 0-2.696-1.11c-2.04 0-3.693 1.574-3.693 3.517 0 .276.033.545.096.802C5.795 4.228 3.075 2.828 1.253.7c-.318.52-.5 1.124-.5 1.769 0 1.22.652 2.297 1.643 2.928a3.819 3.819 0 0 1-1.673-.44V5c0 1.705 1.273 3.127 2.962 3.45a3.876 3.876 0 0 1-1.667.06c.47 1.398 1.833 2.415 3.45 2.444A7.646 7.646 0 0 1 .88 12.46c-.298 0-.592-.017-.881-.05a10.833 10.833 0 0 0 5.66 1.581c6.793 0 10.508-5.36 10.508-10.01a9.68 9.68 0 0 0-.01-.455A7.32 7.32 0 0 0 18 1.705Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "twitter-logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v14H0z"
  })))));
};
export default SvgTwitterLogo;